// extracted by mini-css-extract-plugin
export default {"report-presence__container":"styles_report-presence__container__TX2qw","report-presence__content":"styles_report-presence__content__uhrqW"};